import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AlertOptions, AlertState } from '@shared/interfaces/alert.interface';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  // Usamos el State para que el componente visual (HTML) reaccione
  private state = new BehaviorSubject<AlertState | null>(null);
  state$ = this.state.asObservable();

  // Cambiamos el resolver único por un manejo más seguro
  private resolver?: (value: boolean) => void;

  /**
   * Abre la alerta y retorna una promesa que se resuelve al interactuar.
   */
  async open(options: AlertOptions): Promise<boolean> {
    // Si ya hay una alerta abierta, podrías implementar una cola aquí,
    // pero para este MVP, cerramos la anterior para evitar bloqueos.
    if (this.state.getValue()) {
      this.close();
    }

    this.state.next({
      ...options,
      isOpen: true
    });

    return new Promise<boolean>((resolve) => {
      this.resolver = resolve;
    });
  }

  // --- Helpers de conveniencia ---

  async success(title: string, message: string): Promise<boolean> {
    return this.open({ type: 'success', title, message });
  }

  async error(title: string, message: string): Promise<boolean> {
    return this.open({ type: 'error', title, message });
  }

  async confirm(title: string, message: string): Promise<boolean> {
    return this.open({ type: 'confirm', title, message });
  }

  // --- Controladores de Interacción ---

  accept() {
    if (this.resolver) {
      this.resolver(true);
      this.resolver = undefined; // Limpiamos para evitar ejecuciones dobles
    }
    this.close();
  }

  cancel() {
    if (this.resolver) {
      this.resolver(false);
      this.resolver = undefined;
    }
    this.close();
  }

  close() {
    this.state.next(null);
  }
}
